<div>
  <form  (ngSubmit)="onConfirmSubmit()" autocomplete="off">
    <ng-container ssTrackEvent [event]="track.changeMobileConfirmPageview"></ng-container>
    <h1 class="text-title-4 mb-8">
      {{ 'rogers.changeUsername.confirmReoveryNumber.header' | translate }}
    </h1>

    @if (error === 'tooManyAttemptsOrExpired') {
      <div class="mb-16">
        <ds-alert
          variant="error"
          [closeLabel]="'rogers.login.popOverClose' | translate"
          (closeClick)="resetErrorMessage()"
          role="alert"
          ssTrackError
          [error]="track.changeMobileConfirmErrors">
          <div class="d-flex flex-column flex-md-row">
            <div class="flex-grow-1 d-flex">
              <ds-icon
                class="mr-8"
                name="error-outlined"
                color="error"
                [ariaHidden]="false"
                [attr.title]="'rogers.login.accessibility.error' | translate"
                caption="Attention">
              </ds-icon>
              <div>
                <p damTranslationWithRouting
                  class="text-body mb-0 mw-content">
                  {{ 'rogers.verifySms.error.tooManyAttemptsOrExpired' | translate }}
                </p>
              </div>
            </div>
          </div>
        </ds-alert>
      </div>
    }


    @if (newRecoveryNumber) {
      <div class="text-body-lg mb-10 mt-10">
        <p><strong>{{ newRecoveryNumber }}</strong> {{ changeRecoveryNumberDesc | translate }}</p>
      </div>
    }

    <div class="mb-16">
      <p class="text-body mb-0 mw-content">{{ 'rogers.changeUsername.confirmReoveryNumber.middleText' | translate }}</p>
    </div>
    <button
      type="submit"
      ds-button
      class="w-100 mt-12"
      [ngClass]="{'mb-48': hideBackBtn, 'mb-24': !hideBackBtn}"
      title="{{ 'rogers.changeUsername.confirmReoveryNumber.continueAlt' | translate }}"
      #continueBtn
      >
      @if (!confirmRecoveryNumberInProgress) {
        <span>{{ 'common.confirm' | translate }}</span>
      }
      @if (confirmRecoveryNumberInProgress) {
        <eas-loader class="eas-loader"></eas-loader>
      }
    </button>
  </form>
</div>
